'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import type React from 'react';
import { Fragment } from 'react';
import { cn } from '../../../shared/cn';
export type ListboxOptionProps = {
  className?: string;
  children?: React.ReactNode;
};
export function ListboxOption(t0) {
  const $ = _c(11);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex min-w-0 items-center", "*:data-[slot=icon]:size-5 *:data-[slot=icon]:shrink-0 sm:*:data-[slot=icon]:size-4", "*:data-[slot=icon]:text-zinc-500 group-data-focus/option:*:data-[slot=icon]:text-white dark:*:data-[slot=icon]:text-zinc-400", "forced-colors:*:data-[slot=icon]:text-[CanvasText] forced-colors:group-data-focus/option:*:data-[slot=icon]:text-[Canvas]", "*:data-[slot=avatar]:-mx-0.5 *:data-[slot=avatar]:size-6 sm:*:data-[slot=avatar]:size-5");
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const sharedClasses = t1;
  let t2;
  if ($[5] !== children || $[6] !== className) {
    t2 = t3 => {
      const {
        selectedOption
      } = t3;
      if (selectedOption) {
        return <span className={cn(sharedClasses, "overflow-hidden", className)}><span className="block min-w-0 truncate">{children}</span></span>;
      }
      return <div className={cn("group/option grid cursor-default grid-cols-[--spacing(5)_1fr] items-baseline gap-x-2 rounded-lg py-2.5 pr-3.5 pl-2 sm:grid-cols-[--spacing(4)_1fr] sm:py-1.5 sm:pr-3 sm:pl-1.5", "text-contentPrimary text-sm/5 forced-colors:text-[CanvasText]", "data-focus:text-contentInversePrimary", "hover:bg-backgroundHover hover:text-contentInversePrimary data-focus:bg-backgroundHover", "forced-color-adjust-none forced-colors:data-focus:bg-[Highlight] forced-colors:data-focus:text-[HighlightText]", "data-disabled:opacity-50 data-disabled:cursor-not-allowed", className)}><svg data-slot="icon" className="hidden size-5 self-center stroke-contentSecondary group-data-selected/option:inline group-data-focus/option:stroke-current sm:size-4" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 8.5l3 3L12 4" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg><span className={cn(sharedClasses, "col-start-2")}>{children}</span></div>;
    };
    $[5] = children;
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t2) {
    t3 = <Headless.ListboxOption as={Fragment} {...props}>{t2}</Headless.ListboxOption>;
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}